module.exports = __webpack_public_path__ + "img/bible.dd0ea635.jpg";